export const PAYMENT_ISSUE_STATUSES = ['past_due', 'unpaid']
export const HEALTHY_SUBSCRIPTION_STATUSES = ['active', 'trialing']
export const PAYMENT_GRACE_DAYS = 3
export const PAYMENT_GRACE_MS = PAYMENT_GRACE_DAYS * 24 * 60 * 60 * 1000

export const PAYMENT_ISSUE_MODAL_COPY =
  'We encountered an issue with the payment method associated with your account. Please update your payment information to avoid any interruption to your Premium Tier Access.'

/**
 * Resolve tier + grace fields from a Stripe subscription status and any existing grace window.
 * Pure helper mirrored by stripe-webhook logic.
 */
export const resolveBillingAccess = ({
  status,
  existingGraceEndsAt = null,
  existingIssueNoticedAt = null,
  now = new Date()
} = {}) => {
  const currentTime = now instanceof Date ? now : new Date(now)

  if (HEALTHY_SUBSCRIPTION_STATUSES.includes(status)) {
    return {
      tier: 'premium',
      paymentGraceEndsAt: null,
      paymentIssueNoticedAt: null
    }
  }

  if (PAYMENT_ISSUE_STATUSES.includes(status)) {
    const existingEnds = existingGraceEndsAt ? new Date(existingGraceEndsAt) : null

    if (existingEnds && !Number.isNaN(existingEnds.getTime())) {
      if (existingEnds > currentTime) {
        return {
          tier: 'premium',
          paymentGraceEndsAt: existingEnds.toISOString(),
          paymentIssueNoticedAt: existingIssueNoticedAt || null
        }
      }

      return {
        tier: 'free',
        paymentGraceEndsAt: existingEnds.toISOString(),
        paymentIssueNoticedAt: existingIssueNoticedAt || null
      }
    }

    const noticedAt = currentTime.toISOString()
    const graceEndsAt = new Date(currentTime.getTime() + PAYMENT_GRACE_MS).toISOString()

    return {
      tier: 'premium',
      paymentGraceEndsAt: graceEndsAt,
      paymentIssueNoticedAt: noticedAt
    }
  }

  return {
    tier: 'free',
    paymentGraceEndsAt: null,
    paymentIssueNoticedAt: null
  }
}

export const isPaymentIssueInGrace = ({
  subscriptionStatus,
  paymentGraceEndsAt,
  now = new Date()
} = {}) => {
  if (!PAYMENT_ISSUE_STATUSES.includes(subscriptionStatus)) return false
  if (!paymentGraceEndsAt) return false

  const endsAt = new Date(paymentGraceEndsAt)
  if (Number.isNaN(endsAt.getTime())) return false

  const currentTime = now instanceof Date ? now : new Date(now)
  return endsAt > currentTime
}
